// import components
import { styled, alpha, Box } from '@mui/material';
import TableCRUDLayout from 'components/shared/CRUD/TableCRUDLayout';

// import types
import { DutyLineGridRow } from './HoursTable.types';

export const StyledHoursTableCRUDLayout = styled(
  TableCRUDLayout<DutyLineGridRow>
)(({ theme }) => ({
  //  highlight editable cells of the selected row
  '& .MuiDataGrid-row.active-row .MuiDataGrid-cell--editable': {
    backgroundColor: alpha(theme.palette.primary.main, 0.1),
    cursor: 'pointer'
  },

  '& .stripedRow-even': {
    backgroundColor: 'transparent'
  },

  '& .weekend-row': {
    backgroundColor: theme.vars.palette.grey[100]
  },

  '& .MuiDataGrid-row--editing': {
    boxShadow: `1px 0 24px 0px #bcd5d46e, 0 2px 3px #52525254`,
    zIndex: 4
  },

  '& .weekend-row .MuiDataGrid-cell--pinnedLeft': {
    backgroundColor: theme.vars.palette.surface.containerHigh
  },

  '& .MuiDataGrid-columnHeader--pinnedRight, .MuiDataGrid-cell--pinnedRight, .MuiDataGrid-scrollbarFiller.MuiDataGrid-scrollbarFiller--pinnedRight':
    {
      backgroundColor: '#fcfcf9'
    },
  '& .weekend-row .MuiDataGrid-columnHeader--pinnedRight, .weekend-row .MuiDataGrid-cell--pinnedRight':
    {
      backgroundColor: '#f4f4ed'
    },

  '& .MuiDataGrid-row.blocked-row': {
    color: theme.palette.grey[500],

    '&:hover': {
      cursor: 'not-allowed'
    }
  }
}));

export const StyledHoursTableContainer = styled(Box)(() => ({
  // Note: 355px is the height of the dojo content + appBar,
  // update when the dojo content is changed to React
  height: 'calc(100vh - 355px)',

  '@media only screen and (min-width: 1329px)': {
    height: 'calc(100vh - 335px)'
  }
}));
